<div *ngIf="description" class="pinned">
  <div class="title">
    <h1>{{ description.title | translate }}</h1>
  </div>
  <div class="buttons">
    <label class="count" *ngIf="count">{{ 'results' | plural:count | translate:{value: count} }}</label>
    <bst-table-options-button [count]="filterCount" (open)="events.next(DualAxisEvent.OPENFILTERS)"></bst-table-options-button>
    <button nbButton *ngIf="description.canAdd" [shape]="'semi-round'" type="button" [size]="'small'" [status]="'primary'" (click)="newDirectoryItem()"><nb-icon [icon]="'plus-outline'"></nb-icon>{{ 'additem' | translate:{value: description.title} }}</button>
  </div>
</div>
<bst-dual-axis *ngIf="description" [tag]="'dir_'+name" [delegate]="this"></bst-dual-axis>

<ng-template #cellTemplate let-dir="row" let-column="column" let-node="node">
  <ng-container [ngSwitch]="column.name">
    <div *ngSwitchCase="'definition'" [ngSwitch]="dir[column.name].type" class="edit-row">
      <span *ngSwitchCase="ColType.SCALE.toString()">{{ 'question.scale' | translate }}</span>
      <span *ngSwitchDefault>{{ 'question.text' | translate }}</span>
      <span *ngIf="dir[column.name].required" class="small-label">({{ 'question.required' | translate }})</span>
    </div>
    <div *ngSwitchCase="'editings'">

    </div>
    <span *ngSwitchDefault>{{ dir[column.name] || null }}</span>
  </ng-container>
</ng-template>

<ng-template #question let-col="col" let-form="form">
  <ng-container [formGroup]="form">
    <div class="edit-row">
      <label class="small-label">{{ 'question.type' | translate }}</label>
      <nb-select formControlName="type">
        <nb-option [value]="ColType.STRING.toString()">{{ 'question.text' | translate }}</nb-option>
        <nb-option [value]="ColType.SCALE.toString()">{{ 'question.scale' | translate }}</nb-option>
      </nb-select>
    </div>
    <div *ngIf="form.get('type').value === ColType.SCALE.toString()" class="edit-row">
      <label class="small-label">{{ 'question.details' | translate }}</label>
      <input type="text" fieldSize="small" nbInput [maxlength]="75" [placeholder]="'question.scale_from_name' | translate" formControlName="scale_from_name">
      <input type="number" fieldSize="small" nbInput min="1" max="10" [maxlength]="2" [placeholder]="'question.scale_steps' | translate" formControlName="scale_steps">
      <input type="text" fieldSize="small" nbInput [maxlength]="75" [placeholder]="'question.scale_to_name' | translate" formControlName="scale_to_name">
    </div>
    <div class="edit-row">
      <label class="small-label">{{ 'question.required' | translate }}</label>
      <nb-checkbox formControlName="required"></nb-checkbox>
    </div>
  </ng-container>
</ng-template>
